import React from "react";

import "./PageLoader.css";

const PageLoader = ({
  message = "جاري تحميل البيانات...",
  overlay = false,
}) => {
  return (
    <div
      className={`dga-page-loader ${
        overlay ? "dga-page-loader--overlay" : ""
      }`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span
        className="dga-page-loader__spinner"
        aria-hidden="true"
      />

      <span className="dga-page-loader__message">
        {message}
      </span>
    </div>
  );
};

export default PageLoader;